import { setToEndOFDate } from '@/containers/pages/filials/utils';
import { IFilterConditionItem } from '@/types/api';
import { IFiltersEnumType } from '@/types/enums';
import { IRowData, IUserActivitySortField } from '@components/simple-table/types';

export const convertToFilterConditions = (
  activeFilters: Record<IFiltersEnumType, number[] | Date[]>
): IFilterConditionItem[] => {
  const filterObjects: IFilterConditionItem[] = [];

  for (const [key, value] of Object.entries(activeFilters)) {
    const filterType = +key;
    const filterObject: IFilterConditionItem = {
      Type: filterType
    };

    if (filterType === IFiltersEnumType.DateOfCreateFilter) {
      const [from, to] = value as Date[];
      filterObject.DateRange = {
        From: from?.toISOString(),
        To: setToEndOFDate(new Date(to))
      };
    } else {
      filterObject.NumValues = value as number[];
    }

    filterObjects.push(filterObject);
  }

  return filterObjects;
};

export const transformNumberToSortField = (value: IUserActivitySortField): keyof IRowData => {
  return value in IUserActivitySortField
    ? IUserActivitySortField[value]
    : IUserActivitySortField[IUserActivitySortField?.None];
};

export const transformSortFieldToNumber = (
  value: keyof typeof IUserActivitySortField
): IUserActivitySortField => {
  return getValueByKeyForNumberEnum(value);
};

function getValueByKeyForNumberEnum(value: keyof typeof IUserActivitySortField) {
  const valueFromKey = Object.entries(IUserActivitySortField).find(([key]) => key === value)?.[1];
  return typeof valueFromKey === 'number' && valueFromKey in IUserActivitySortField
    ? valueFromKey
    : IUserActivitySortField.None;
}
